import React from "react";
import useAppContext from "state/AppContext";

export default function CompanyTeams(props) {
  const appContext = useAppContext();
  const { jobPosting } = appContext.selectedOrder;
  const { description, teams } = jobPosting.teamsSection;

  return (
    <div className="my-[100px]">
      <header>
        <h4 className="text-lg text-center font-bold text-gray-800 mb-2">Areas of Work</h4>
        <h2 className="text-5xl text-center font-bold mb-6">Our teams</h2>
        <p className="text-2xl text-center mb-14 w-3/4 mx-auto leading-10 text-gray-800">{description}</p>
      </header>
      <div className="flex flex-wrap justify-between my-10">
        {teams.map((teamItem) => (
          <div key={teamItem.id} className="w-[calc(50%-20px)] shadow-lg rounded-xl overflow-hidden my-2 flex">
            <img className="object-cover w-[150px] h-full" src="https://flowbite.com/docs/images/blog/image-4.jpg" alt="" />
            <div className="p-4 leading-normal flex flex-col justify-center">
              <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">{teamItem.teamName}</h5>
              <p className="mb-3 font-normal text-gray-700 dark:text-gray-400">{teamItem.teamDescription}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
